
import { jsPDF } from "jspdf";
import { PdfHeaderOptions } from "../types";

/**
 * Add PDF header section
 */
export const addHeader = (doc: jsPDF, { companyName, pageWidth, colors }: PdfHeaderOptions): void => {
  // Add header with company name - using techne-purple to techne-deepPurple gradient
  doc.setFillColor(colors?.primaryPurple[0] || 103, colors?.primaryPurple[1] || 36, colors?.primaryPurple[2] || 125);
  doc.rect(0, 0, pageWidth, 40, "F");
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(22);
  doc.text("BoardSight AI Governance Readiness Report", pageWidth / 2, 20, { align: "center" });
  
  doc.setFontSize(14);
  doc.text(`Prepared for: ${companyName}`, pageWidth / 2, 30, { align: "center" });
  
  // Add date
  doc.setTextColor(100, 100, 100);
  doc.setFontSize(10);
  const today = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  doc.text(`Generated on: ${today}`, pageWidth - 15, 50, { align: "right" });
};
